export default __webpack_public_path__ + "static/media/14xx-1.5e4c7743.png";